import { getExplorerSearchDossierDto } from '@bcba/validators';

export const _ExplorerSearchDossierDto = getExplorerSearchDossierDto();
export class ExplorerSearchDossierDto extends _ExplorerSearchDossierDto {}
